import type { SearchHintDto } from '@bldsoft/cappie/api/wbs'
import type { SearchHint } from '@setplex/tria-api/src/entities/global-search/index.h'
import type { ApiType } from '../../../shared/schemas'

import * as v from 'valibot'

export const SearchHintSchema = v.object({
  id: v.number(),
  hintValue: v.optional(v.string()),
  sortOrder: v.optional(v.number()),
}) satisfies ApiType<SearchHintDto, SearchHint>

export const SearchHintsSchema = v.array(SearchHintSchema)
